/* Create by CC 2015-12-05*/
'use strict';
angular.module('iWoSbumitModule', ['iWoSubmitServiceModule', 'mgcrea.ngStrap.timepicker']).controller('iWoSubmitCtrl', [
    '$scope',
    '$timeout',
    '$q',
    '$filter',
    '$state',
    '$modalInstance',
    'trsHttpService',
    'trsspliceString',
    'modalDialog',
    'selectedArray',
    'iWoSbumitService',
    'methodname',
    'editingCenterService',
    'trsColumnTreeLocationService',
    'editIsLock',
    function (
        $scope,
        $timeout,
        $q,
        $filter,
        $state,
        $modalInstance,
        trsHttpService,
        trsspliceString,
        modalDialog,
        selectedArray,
        iWoSbumitService,
        methodname,
        editingCenterService,
        trsColumnTreeLocationService,
        editIsLock
    ) {
        initStatus();
        initData();

        /**
         * [initStatus description] 初始化状态
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.path = {
                newPath: {},
                pathArray: [],
            };

            /**
             * [cur description]记录渠道 站点 报纸等当前选中状态
             * @type {Object}
             */
            $scope.cur = {
                medias: iWoSbumitService.initMediaName(),
                currMedia: {},
                currSite: {},
                currChannel: {},
                currDieci: {},
            };
            $scope.cur.currMedia = $scope.cur.medias[0];
            $scope.params = {
                serviceid: 'mlf_mediasite',
                methodname: 'queryWebSitesByMediaType',
                MediaType: 3,
            };

            /**
             * [status description]各类变量整理
             * @type {Object}
             */
            $scope.status = {
                createDate: editingCenterService.getNewsPaperDate(), // 见报时间 大于8点就为第二天
                // createDate: new Date().setDate(new Date().getDate() + 1), // 见报时间
                treeOptions: iWoSbumitService.initTreeOpition(), // 网站树配置
                appTreeOptions: iWoSbumitService.initAppTreeOption(), //
                scalingMenu: true, //
                mediaType: {
                    // 渠道分类
                    app: '1',
                    website: '2',
                    newspaper: '3',
                    weixin: '4',
                    scapp: '',
                    weibo: '5',
                    television: '15',
                    broadcast: '16',
                    tiktok: '17',
                    baijiahao: '18',
                    qiehao: '19',
                    toutiao: '20',
                    kuaishou: '25'
                },
                selectedArr: {
                    // 各渠道下被选中的集合
                    website: {},
                    newspaper: {},
                    app: {},
                    weixin: {},
                    weibo: {},
                    scapp: '',
                    television: {},
                    broadcast: {},
                    tiktok: {},
                    baijiahao: {},
                    qiehao: {},
                    toutiao: {},
                    kuaishou: {}
                },
                accessAuthority: {}, // 渠道权限
                initializeFun: {
                    newspaper: 'initializeNewsPaper()',
                    website: 'initializeWebsite()',
                    app: 'initializeApp()',
                    scapp: 'initializeScapp()',
                    television: 'initializeTv()',
                    broadcast: 'initializeBroadcast()',
                },
            };
            $scope.data = {
                newspaper: {
                    dieciList: [], // 叠次列表
                    banmianList: [], // 版面列表
                },
                website: {
                    columns: [], // 栏目
                },
                app: {
                    columns: [], // 栏目
                },
                weixin: {
                    selectedArray: [],
                },
                weibo: {
                    selectedArray: [],
                },
                tiktok: {
                    selectedArray: [],
                },
                kuaishou: {
                    selectedArray: [],
                },
                baijiahao: {
                    selectedArray: [],
                },
                qiehao: {
                    selectedArray: [],
                },
                toutiao: {
                    selectedArray: [],
                },
                scapp: {
                    applistName: ['频道', '地市'], // 数采app暂时只具有两个分类
                    appListData: [], // 数采app分类列表
                    selectedAppData: '', // 数采app中被选中的节点
                },
                selectedNode: {}, // 树结构上被选中的节点
                appSelectedNode: {},
                hasSelectedCHANNELIDs: {},
                television: {
                    columns: [],
                    selectedArray: [],
                },
                broadcast: {
                    columns: [],
                    selectedArray: [],
                },
                selectedWeiboType: '16'
            };
        }

        /**
         * [initializeNewsPaper description]初始化报纸渠道
         * @return {[type]} [description]
         */
        function initializeNewsPaper() {
            getDieciList($scope.data.newspaper.selectedItem).then(function (data) {
                getBanmianList();
            });
        }

        /**
         * [initializeWebsite description]初始化网站渠道
         * @return {[type]} [description]
         */
        function initializeWebsite() {
            getWebsiteColumn($scope.data.website.selectedItem);
        }

        /**
         * [initializeApp description] 初始化APP渠道
         * @return {[type]} [description]
         */
        function initializeApp() {
            getAppColumn($scope.data.app.selectedItem);
        }

        /**
         * [initializeTv description] 初始化电视渠道
         * @return  {[type]}  [return description]
         */
        function initializeTv() {
            getTvColumn($scope.data.television.selectedItem);
        }

        /**
         * [initializeBroadcast description] 初始化广播渠道
         * @return  {[type]}  [return description]
         */
        function initializeBroadcast() {
            getBroadcastColumn($scope.data.broadcast.selectedItem);
        }

        /**
         * [initData description] 初始化数据
         * @return  {[type]}  [return description]
         */
        function initData() {
            getAccessAuthority().then(function () {
                var params = {
                    serviceid: 'mlf_mediasite',
                    methodname: 'queryWebSitesByMediaType',
                    MediaType: $scope.params.MediaType,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                    if (data.length === 0) {
                        return;
                    }
                    data.DATA.forEach(function (item) {
                        item.CHANNELID = item.ACCOUNTID || item.DOUYINACCOUNTID || item.BAIJIAHAOACCOUNTID || item.KUAIBAOACCOUNTID || item.CHANNELID;
                        item.CHNLDESC = item.ACCOUNTNAME ? item.ACCOUNTNAME : item.CHNLDESC;
                    });
                    $scope.data[$scope.cur.currMedia.type].lists = data.DATA;
                    $scope.data[$scope.cur.currMedia.type].selectedItem = data.DATA[0];
                    eval($scope.status.initializeFun[$scope.cur.currMedia.type]);
                });
            });
        }
        // 关闭窗口
        $scope.close = function () {
            $modalInstance.dismiss();
        };
        // 删除路径
        $scope.deleteTrack = function (index, path, way) {
            $scope.path.pathArray.splice(index, 1);
            if (way) {
                $scope.data[way].selectedArray.splice($scope.data[way].selectedArray.indexOf(path.channelId), 1);
            }
            delSelectedArrFn(path);
        };
        // 点击确定
        $scope.confirm = function () {
            if (!$scope.path.pathArray.length) {
                modalDialog.alertType('请选择渠道', '', 'info', 'confirm', function () { });
                return;
            }
            var paths = $state.current.name.split('.');
            var web = [];
            var paper = [];
            var app = []; // 数采APP
            var MlfApp = []; // 媒立方APP
            var WeChat = [];
            var MicroBlog = [];
            var TvWenGao = []; // 电视
            var BroadCastWenGao = []; // 广播
            var tiktok = []; // 抖音
            var baijiahao = []; // 百家号
            var qiehao = []; // 企鹅号
            var toutiao = []; // 头条号
            var kuaishou = []; // 快手
            var params;
            if (paths[3] === 'departmentManuscript' || $state.params.fromType === 'departmentmanuscript') {
                params = {
                    serviceid: 'mlf_departoperdoc',
                    methodname: 'submit',
                    ChnlDocIds: trsspliceString.spliceString(selectedArray, 'CHNLDOCID', ','),
                    DepartmentaldocId: $state.params.departmentDocId || $state.params.departmentaldocid,
                    PaperPubDate: '',
                };
            } else {
                params = {
                    serviceid: $state.current.name === 'reportsummarynews' ? 'mlf_myrelease' : 'mlf_fusionmyrelease',
                    methodname: methodname,
                    ChnlDocIds: trsspliceString.spliceString(selectedArray, 'CHNLDOCID', ','),
                    MetaDataIds: trsspliceString.spliceString(selectedArray, 'METADATAID', ','),
                };
            }
            // 根据pathArray区分提交渠道
            angular.forEach($scope.path.pathArray, function (value, key) {
                value.mediaType = value.mediaType.toString();
                if (value.mediaType === $scope.status.mediaType.website) {
                    web.push({
                        channelId: value.channelId,
                    });
                } else if (value.mediaType === $scope.status.mediaType.newspaper) {
                    paper.push({
                        channelId: value.channelId,
                    });
                } else if (value.mediaType === $scope.status.mediaType.scapp) {
                    app.push({
                        channelId: value.channelId,
                    });
                } else if (value.mediaType === $scope.status.mediaType.app) {
                    MlfApp.push({
                        channelId: value.channelId,
                    });
                } else if (value.mediaType === $scope.status.mediaType.weixin) {
                    WeChat.push({
                        channelId: value.channelId,
                    });
                } else if (value.mediaType === $scope.status.mediaType.weibo) {
                    MicroBlog.push({
                        channelId: value.channelId,
                    });
                } else if (value.mediaType === $scope.status.mediaType.television) {
                    TvWenGao.push({
                        channelId: value.channelId,
                    });
                } else if (value.mediaType === $scope.status.mediaType.broadcast) {
                    BroadCastWenGao.push({
                        channelId: value.channelId,
                    });
                } else if (value.mediaType === $scope.status.mediaType.tiktok) {
                    tiktok.push({
                        channelId: value.channelId,
                    });
                } else if (value.mediaType === $scope.status.mediaType.baijiahao) {
                    baijiahao.push({
                        channelId: value.channelId,
                    });
                } else if (value.mediaType === $scope.status.mediaType.qiehao) {
                    qiehao.push({
                        channelId: value.channelId,
                    });
                } else if (value.mediaType === $scope.status.mediaType.toutiao) {
                    toutiao.push({
                        channelId: value.channelId,
                    });
                } else if (value.mediaType === $scope.status.mediaType.kuaishou) {
                    kuaishou.push({
                        channelId: value.channelId,
                    });
                }
            });
            params.webs = trsspliceString.spliceString(web, 'channelId', ',');
            params.papers = trsspliceString.spliceString(paper, 'channelId', ',');
            params.app = trsspliceString.spliceString(app, 'channelId', ',');
            params.MlfApp = trsspliceString.spliceString(MlfApp, 'channelId', ',');
            params.WeChat = trsspliceString.spliceString(WeChat, 'channelId', ',');
            params.MicroBlog = trsspliceString.spliceString(MicroBlog, 'channelId', ',');
            params.TvWenGao = trsspliceString.spliceString(TvWenGao, 'channelId', ',');
            params.BroadCastWenGao = trsspliceString.spliceString(BroadCastWenGao, 'channelId', ',');
            params.tiktok = trsspliceString.spliceString(tiktok, 'channelId', ',');
            params.baijiahao = trsspliceString.spliceString(baijiahao, 'channelId', ',');
            params.kuaibao = trsspliceString.spliceString(qiehao, 'channelId', ',');
            params.toutiao = trsspliceString.spliceString(toutiao, 'channelId', ',');
            params.kuaishou = trsspliceString.spliceString(kuaishou, 'channelId', ',');
            if (params.papers.length) {
                params.PaperPubDate = $filter('date')($scope.status.createDate, 'yyyy-MM-dd').toString();
            }
            if (params.MicroBlog.length) {
                params.microblogDocType = $scope.data.selectedWeiboType;
            }
            if ($state.params.iwometadataid) { // 部门看稿库需要解锁,但是目前路由问题会刷新页面，所以暂时解锁一遍
                editIsLock.normalLock($state.params.iwometadataid).then(() => {
                    $modalInstance.close(params);
                });
            } else {
                $modalInstance.close(params);
            }
        };

        // 点击一级站点
        $scope.setCurrMedia = function (media) {
            $scope.cur.currMedia = media;
            if ($scope.data[$scope.cur.currMedia.type].lists) {
                return;
            } // 请求过后退出
            var params = {
                serviceid: 'mlf_mediasite',
                methodname: 'queryWebSitesByMediaType',
                MediaType: media.mediaType,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                data.DATA.forEach(function (item) {
                    item.CHANNELID = item.ACCOUNTID || item.DOUYINACCOUNTID || item.BAIJIAHAOACCOUNTID || item.KUAIBAOACCOUNTID || item.CHANNELID; // 兼容新媒体渠道
                    if (media.mediaType === 4) {
                        item.CHNLDESC = item.CHNLDESC;
                    } else {
                        item.CHNLDESC = item.ACCOUNTNAME != undefined ? item.ACCOUNTNAME : item.CHNLNAME ? item.CHNLNAME : item.CHNLDESC;
                    }
                });
                $scope.data[$scope.cur.currMedia.type].lists = data.DATA;
                if (angular.isDefined(data.DATA)) {
                    $scope.data[$scope.cur.currMedia.type].selectedItem = data.DATA[0];
                }
                eval($scope.status.initializeFun[$scope.cur.currMedia.type]);
                if ($scope.cur.currMedia.type === 'app' && $scope.data.app.selectedItem.SITETYPE == '-1') {
                    initializeScapp();
                }
            });
        };

        /**
         * [selectSite description] 点击网站或APP选择栏目
         * @param   {[type]}  site  [site description] 当前站点信息
         * @param   {[type]}  type  [type description]
         * @return  {[type]}        [return description]
         */
        $scope.selectSite = function (site, type) {
            if (type === 'website') {
                $scope.data.expandedTest = [];
                $scope.data.website.selectedItem = site;
                $scope.status.scalingMenu = true;
                $scope.data.channelFilter = '';
                getWebsiteColumn(site);
            } else if (type === 'app' && site.SITETYPE != '-1') {
                $scope.data.appExpandedTest = [];
                $scope.data.app.selectedItem = site;
                $scope.status.scalingMenu = true;
                $scope.data.appChannelFilter = '';
                getAppColumn(site);
            } else if (type === 'app' && site.SITETYPE == '-1') {
                $scope.data.app.selectedItem = site;
                initializeScapp();
            } else if (type === 'television') {
                $scope.data.television.selectedItem = site;
                $scope.data.tvChannelFilter = '';
                getTvColumn(site);
            } else if (type === 'broadcast') {
                $scope.data.broadcast.selectedItem = site;
                $scope.data.broadcastChannelFilter = '';
                getBroadcastColumn(site);
            }
        };

        /**
         * [selectChannel description] 选择微信、微博栏目
         * @param  {[type]} channel [description]
         * @param {[type]} [way] [description] 区分微信、微博渠道
         * @return {[type]}         [description]
         */
        $scope.selectChannel = function (channel, way) {
            if ($scope.data[way].selectedArray.indexOf(channel.CHANNELID) < 0) {
                $scope.data[way].selectedArray.push(channel.CHANNELID);
                getSelectedChannel(channel);
            } else {
                $scope.data[way].selectedArray.splice($scope.data[way].selectedArray.indexOf(channel.CHANNELID), 1);
                angular.forEach($scope.path.pathArray, function (data, index, path) {
                    if (data.channelId === channel.CHANNELID) {
                        $scope.path.pathArray.splice(index, 1);
                    }
                });
            }
        };

        /**
         * [getWebsiteColumn description]获得网站站点下的栏目
         * @param  {[obj]} site [description]当前站点信息
         * @return {[type]}      [description]
         */
        function getWebsiteColumn(site) {
            var deffer = $q.defer();
            var params = {
                serviceid: 'mlf_mediasite',
                methodname: 'queryClassifyBySite',
                SiteId: site.SITEID,
                platform: 1,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                $scope.data.website.columns = data;
                deffer.resolve(data);
            });
            return deffer.promise;
        }

        /**
         * [getAppColumn description] 获得APP站点下的栏目
         * @param  {[type]} site [description]
         * @return {[type]}      [description]
         */
        function getAppColumn(site) {
            var deffer = $q.defer();
            var params = {
                serviceid: 'mlf_mediasite',
                methodname: 'queryClassifyBySite',
                SiteId: site.SITEID,
                platform: 7,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                $scope.data.app.columns = data;
                deffer.resolve(data);
            });
            return deffer.promise;
        }

        /**
         * [getTvColumn description] 获取电视站点下的栏目
         * @param  {[type]} site [description]
         * @return {[type]}      [description]
         */
        function getTvColumn(site) {
            var deffer = $q.defer();
            var params = {
                serviceid: 'mlf_tv',
                methodname: 'getAllChannelsOfDaibian',
                webSiteId: site.SITEID,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                if (Object.prototype.toString.call(data) == '[object Array]') {
                    $scope.data.television.columns = data;
                } else {
                    $scope.data.television.columns = [];
                }
                deffer.resolve(data);
            });
            return deffer.promise;
        }

        /**
         * [getBroadcastColumn 获取广播站点下的栏目]
         * @param  {[type]} site [description]
         * @return {[type]}      [description]
         */
        function getBroadcastColumn(site) {
            var defer = $q.defer();
            var params = {
                serviceid: 'mlf_broadcast',
                methodname: 'getAllChannelsOfDaibian',
                webSiteId: site.SITEID,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                if (Object.prototype.toString.call(data) == '[object Array]') {
                    $scope.data.broadcast.columns = data;
                } else {
                    $scope.data.broadcast.columns = [];
                }
                defer.resolve(data);
            });
            return defer.promise;
        }

        /**
         *[getSuggestions description]搜索栏目
         * @param  {[type]}channelname  [description] 输入栏目名称
         * return {[type]}   null  [description]
         */
        var promise;
        $scope.getSuggestions = function (channelName, type) {
            if (channelName === '') {
                return;
            }
            if (promise) {
                $timeout.cancel(promise);
                promise = null;
            }
            var siteid =
                type === 'website'
                    ? $scope.data.website.selectedItem.SITEID
                    : type === 'app'
                        ? $scope.data.app.selectedItem.SITEID
                        : type === 'television'
                            ? $scope.data.television.selectedItem.SITEID
                            : $scope.data.broadcast.selectedItem.SITEID;
            promise = $timeout(function () {
                var params = {
                    serviceid: 'mlf_mediasite',
                    methodname: 'queryRightClassifyByName',
                    ChannelName: channelName,
                    SiteId: siteid,
                };
                return trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                    return data;
                });
            }, 500);
            return promise;
        };
        $scope.$watch('data.channelFilter', function (newValue, oldValue) {
            if (angular.isObject(newValue)) {
                // 初始化树数据
                getWebsiteColumn($scope.data.website.selectedItem);
                // 清空树展开
                $scope.data.expandedTest = [];
                // 重新定位树展开位置
                // getPositionData(newValue.CHANNELID);
                trsColumnTreeLocationService.columnTreeLocation(
                    1,
                    newValue.CHANNELID,
                    $scope.data.website.columns,
                    $scope.data.selectedNode,
                    $scope.data.expandedTest,
                    function (tree, array) {
                        delete $scope.data.website.columns;
                        $scope.data.website.columns = tree;
                        $scope.status.selectedArr.website[$scope.data.website.selectedItem.SITEID] = array.pop();
                        getSelectedChannel(newValue);
                    }
                );
            }
        });
        $scope.$watch('data.appChannelFilter', function (newValue, oldValue) {
            if (angular.isObject(newValue)) {
                // 初始化树数据
                getAppColumn($scope.data.app.selectedItem);
                // 清空树展开
                $scope.data.appExpandedTest = [];
                // 重新定位树展开位置
                // getPositionData(newValue.CHANNELID);
                trsColumnTreeLocationService.columnTreeLocation(
                    7,
                    newValue.CHANNELID,
                    $scope.data.app.columns,
                    $scope.data.appSelectedNode,
                    $scope.data.appExpandedTest,
                    function (tree, array) {
                        delete $scope.data.app.columns;
                        $scope.data.app.columns = tree;
                        $scope.status.selectedArr.app[$scope.data.app.selectedItem.SITEID] = array.pop();
                        getSelectedChannel(newValue);
                    }
                );
            }
        });
        $scope.$watch('data.tvChannelFilter', function (newValue, oldValue) {
            if (angular.isObject(newValue)) {
                // 初始化树数据
                getTvColumn($scope.data.television.selectedItem);
                $scope.data.television.selectedArray.push(newValue.CHANNELID);
                $scope.status.selectedArr.television[$scope.data.television.selectedItem.SITEID] == newValue.CHANNELID;
                getSelectedChannel(newValue, 'television');
            }
        });
        $scope.$watch('data.broadcastChannelFilter', function (newValue, oldValue) {
            if (angular.isObject(newValue)) {
                // 初始化树数据
                getBroadcastColumn($scope.data.broadcast.selectedItem);
                $scope.data.broadcast.selectedArray.push(newValue.CHANNELID);
                $scope.status.selectedArr.broadcast[$scope.data.broadcast.selectedItem.SITEID] == newValue.CHANNELID;
                getSelectedChannel(newValue, 'broadcast');
            }
        });

        /**
         * [getDieci description]点击获得报纸站点获得该站点叠次
         * @param  {[type]} newspaper [description]
         * @return {[type]}           [description]
         */
        $scope.getDieci = function (newspaper) {
            getDieciList(newspaper).then(function (data) {
                getBanmianList();
            });
        };

        /**
         * [getBanmian description]点击报纸叠次获得该叠次下的版面
         * @param  {[type]} dieci [description]
         * @return {[type]}       [description]
         */
        $scope.getBanmian = function (dieci) {
            $scope.cur.currDieci = dieci;
            getBanmianList();
        };

        /**
         * [getDieciList description]获得报纸叠次列表
         * @param  {[obj]} newspaper [description]报纸站点信息
         * @return {[obj]}           [description]promise
         */
        function getDieciList(newspaper) {
            var deferred = $q.defer();
            $scope.data.newspaper.selectedItem = newspaper;
            var params = {
                serviceid: 'mlf_paper',
                methodname: 'queryDieCis',
                PaperId: $scope.data.newspaper.selectedItem.SITEID,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                $scope.data.newspaper.dieciList = data;
                $scope.cur.currDieci = data[0];
                deferred.resolve(data);
            });
            return deferred.promise;
        }

        /**
         * [getBanmianList description]获得版面列表
         * @return {[type]} [description]null
         */
        function getBanmianList() {
            $scope.data.newspaper.banmianList = [];
            var params = {
                serviceid: 'mlf_paper',
                methodname: 'queryCaiBianBanMians',
                PaperId: $scope.data.newspaper.selectedItem.SITEID,
            };
            if ($scope.cur.currDieci) {
                params.DieCiId = $scope.cur.currDieci.CHANNELID;
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                    $scope.data.newspaper.banmianList = data;
                });
            }
        }

        /**
         * [getSelectedChannel description]
         * @param  {[type]} node    [description]
         * @param  {[type]} channel [description]
         * @return {[type]}         [description]
         */
        function getSelectedChannel(node, channel) {
            var siteId = {
                '5': 'weiboSite', // 微博
                '17': 'douyinSite', // 抖音
                '18': 'baijiahaoSite', // 百家号
                '19': 'qiehaoSite', // 企鹅号
                '20': 'toutiaoSite', // 头条号
                '25': 'kuaishou' // 快手
            };
            if (channel) {
                node.SITEID = $scope.data[channel].selectedItem.SITEID;
            } else {
                node.SITEID = angular.isDefined(node.SITEID) ? node.SITEID : siteId[node.mediaType];
            }
            var flag = true,
                same = true,
                siteid;
            // 用于取消选中
            /**
             * [isEmptyObject description] 判断对象是否为空
             * @param   {[type]}  e  [e description]
             * @return  {[type]}     [return description]
             */
            function isEmptyObject(e) {
                var t;
                for (t in e) {
                    return !1;
                }
                return !0;
            }
            if (isEmptyObject($scope.data.hasSelectedCHANNELIDs)) {
                var siteid = angular.copy(node.SITEID);
                $scope.data.hasSelectedCHANNELIDs[node.SITEID] = node.CHANNELID;
            } else {
                if ($scope.data.hasSelectedCHANNELIDs[node.SITEID]) {
                    if ($scope.data.hasSelectedCHANNELIDs[node.SITEID] == node.CHANNELID) {
                        delete $scope.status.selectedArr[$scope.cur.currMedia.type][node.SITEID];
                        delete $scope.data.hasSelectedCHANNELIDs[node.SITEID];
                        siteid = '';
                    } else {
                        $scope.data.hasSelectedCHANNELIDs[node.SITEID] = node.CHANNELID;
                        // $scope.data.hasSelectedCHANNELIDs.push(node.CHANNELID);
                        siteid = angular.copy(node.SITEID);
                    }
                } else {
                    siteid = angular.copy(node.SITEID);
                    $scope.data.hasSelectedCHANNELIDs[node.SITEID] = node.CHANNELID;
                }
            }

            $scope.cur.currChannel = node;
            $scope.path.newPath = {
                mediaName: $scope.cur.currMedia.mediaName,
                mediaType: $scope.cur.currMedia.mediaType,
                siteName: $scope.data[$scope.cur.currMedia.type].selectedItem.SITEDESC,
                siteId: $scope.data[$scope.cur.currMedia.type].selectedItem.SITEID,
                channelName: $scope.cur.currChannel.CHNLDESC,
                channelId: $scope.cur.currChannel.CHANNELID,
            };
            angular.forEach($scope.path.pathArray, function (value, key) {
                if (value.channelId === $scope.path.newPath.channelId) {
                    flag = false;
                    same = false;
                    $scope.key = key;
                } else if (
                    (value.mediaType == 1 ||
                        value.mediaType == 2 ||
                        value.mediaType == 3) &&
                    // value.mediaType != 19 &&
                    // value.mediaType != 20 &&
                    // value.mediaType != 18 &&
                    // value.mediaType != 17 &&
                    // value.mediaType != 5 &&
                    // value.mediaType != 4 &&
                    value.siteId === $scope.path.newPath.siteId
                ) {
                    // 单选按钮区分
                    $scope.path.pathArray[key].channelName = $scope.path.newPath.channelName;
                    $scope.path.pathArray[key].channelId = $scope.path.newPath.channelId;
                    flag = false;
                }
            });
            if (flag === true) {
                $scope.path.pathArray.push($scope.path.newPath);
            }
            if (same === false) {
                $scope.path.pathArray.splice($scope.key, 1);
            }

            setSelectedArrFn($scope.path.newPath.mediaType, siteid, node.CHANNELID);
        }
        // 点击三级站点或版面
        $scope.getChannel = function (node, $event) {
            // 选择APP渠道时，判断当前稿件类型是否满足该栏目允许的稿件类型
            if ($scope.cur.currMedia.mediaType == 1) {
                var params = {
                    serviceid: 'mlf_appoper',
                    methodname: 'checkCanSubmitToChannel',
                    metadataids: trsspliceString.spliceString(selectedArray, 'METADATAID', ','),
                    channelId: node.CHANNELID,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                    getChannel(node, $event);
                });
            } else {
                getChannel(node, $event);
            }
        };

        /**
         * [getChannel description] 点击三级站点或版面
         * @param  {[type]} node   [description] 当前节点
         * @param  {[type]} $event [description] 当前事件
         * @return {[type]}        [description]
         */
        function getChannel(node, $event) {
            $scope.data.channelFilter = '';
            $scope.data.appChannelFilter = '';
            getSelectedChannel(node);
            // 切换样式
            if (
                $(event.target)
                    .parents('.tree-label')
                    .hasClass('tree-selected')
            ) {
                $(event.target)
                    .parents('.tree-label')
                    .removeClass('tree-selected');
            } else {
                $(event.target)
                    .parents('.tree-label')
                    .addClass('tree-selected');
            }
        }

        /**
         * [setSelectedArrFn description] 用于存贮选中的条目的方法
         * @param   {[type]}  type       [type description]
         * @param   {[type]}  siteId     [siteId description]
         * @param   {[type]}  channelId  [channelId description]
         * @return  {[type]}             [return description]
         */
        function setSelectedArrFn(type, siteId, channelId) {
            switch (type) {
                case 1:
                    $scope.status.selectedArr.app[siteId] = channelId;
                    if (!siteId) {
                        delete $scope.status.selectedArr.app[siteId];
                    }
                    break;
                case 2:
                    $scope.status.selectedArr.website[siteId] = channelId;
                    if (!siteId) {
                        delete $scope.status.selectedArr.website[siteId];
                    }
                    break;
                case 3:
                    $scope.status.selectedArr.newspaper[siteId] = channelId;
                    if (!siteId) {
                        delete $scope.status.selectedArr.newspaper[siteId];
                    }
                    break;
                case 4:
                    $scope.status.selectedArr.weixin[channelId] = channelId;
                    break;
                case 5:
                    $scope.status.selectedArr.weibo[channelId] = channelId;
                    break;
                case '':
                    $scope.status.selectedArr.scapp = channelId;
                    break;
                case 15:
                    $scope.status.selectedArr.television[siteId] = channelId;
                    if (!siteId) {
                        delete $scope.status.selectedArr.television[siteId];
                    }
                    break;
                case 16:
                    $scope.status.selectedArr.broadcast[siteId] = channelId;
                    if (!siteId) {
                        delete $scope.status.selectedArr.broadcast[siteId];
                    }
                    break;
                case 17:
                    $scope.status.selectedArr.tiktok[channelId] = channelId;
                    break;
                case 18:
                    $scope.status.selectedArr.baijiahao[channelId] = channelId;
                    break;
                case 19:
                    $scope.status.selectedArr.qiehao[channelId] = channelId;
                    break;
                // case 19:
                //     $scope.status.selectedArr.toutiao[channelId] = channelId;
                //     break;
                case 20:
                    $scope.status.selectedArr.toutiao[channelId] = channelId;
                    break;
                case 25:
                    $scope.status.selectedArr.kuaishou[channelId] = channelId;
                    break;
            }
        }

        /**
         * [delSelectedArrFn description] 用于删除选中的条目的方法
         * @param   {[type]}  item  [item description]
         * @return  {[type]}        [return description]
         */
        function delSelectedArrFn(item) {
            switch (item.mediaType) {
                case 1:
                    delete $scope.status.selectedArr.app[item.siteId];
                    break;
                case 2:
                    delete $scope.status.selectedArr.website[item.siteId];
                    break;
                case 3:
                    delete $scope.status.selectedArr.newspaper[item.siteId];
                    break;
                case 4:
                    delete $scope.status.selectedArr.weixin[item.channelId];
                    break;
                case 5:
                    delete $scope.status.selectedArr.weibo[item.channelId];
                    break;
                case '':
                    $scope.status.selectedArr.scapp = '';
                    break;
                case 15:
                    delete $scope.status.selectedArr.television[item.siteId];
                    break;
                case 16:
                    delete $scope.status.selectedArr.broadcast[item.siteId];
                    break;
                case 17:
                    delete $scope.status.selectedArr.tiktok[item.siteId];
                    break;
                case 18:
                    delete $scope.status.selectedArr.baijiahao[item.siteId];
                    break;
                case 19:
                    delete $scope.status.selectedArr.qiehao[item.siteId];
                    break;
                case 20:
                    delete $scope.status.selectedArr.toutiao[item.siteId];
                    break;
                case 25:
                    delete $scope.status.selectedArr.kuaishou[item.siteId];
                    break;
            }
            delete $scope.data.hasSelectedCHANNELIDs[item.siteId];
        }
        // 伸缩菜单,暂时停用
        // $scope.scalingMenu = function() {
        //     $scope.status.scalingMenu = !$scope.status.scalingMenu;
        // };
        /**
         * [getAccessAuthority description]获得提交中各渠道的权限
         * @return {[type]} [description]
         */
        function getAccessAuthority() {
            var deferred = $q.defer();
            var status = {};
            var docType = selectedArray[0].DOCTYPEID;
            var newsObj;
            editingCenterService.getPermissions(docType, true).then(function (data) {
                if (angular.isDefined(data.newspaper)) {
                    newsObj = data.newspaper; // 调整data对象的属性顺序，将newspaper放到最后
                    delete data.newspaper;
                    data.newspaper = newsObj;
                }
                if (angular.isDefined(data.television)) {
                    // 将电视渠道放在最后
                    newsObj = data.television;
                    delete data.television;
                    data.television = newsObj;
                }
                status = data;
                for (var i in status) {
                    switch (i) {
                        case 'app':
                            $scope.status.accessAuthority.app = true;
                            $scope.cur.currMedia = $scope.cur.medias[2];
                            $scope.params.MediaType = 1;
                            break;
                        case 'website':
                            $scope.status.accessAuthority.website = true;
                            $scope.cur.currMedia = $scope.cur.medias[1];
                            $scope.params.MediaType = 2;
                            break;
                        case 'newspaper':
                            $scope.status.accessAuthority.newspaper = true;
                            $scope.cur.currMedia = {
                                mediaName: '纸媒',
                                mediaType: 3,
                            };
                            $scope.cur.currMedia = $scope.cur.medias[0];
                            $scope.params.MediaType = 3;
                            break;
                        case 'weixin':
                            $scope.status.accessAuthority.weixin = true;
                            $scope.cur.currMedia = $scope.cur.medias[3];
                            $scope.params.MediaType = 4;
                            break;
                        case 'weibo':
                            $scope.status.accessAuthority.weibo = true;
                            $scope.cur.currMedia = $scope.cur.medias[4];
                            $scope.params.MediaType = 5;
                            break;
                        case 'broadcast':
                            $scope.status.accessAuthority.broadcast = true;
                            $scope.cur.currMedia = $scope.cur.medias[7];
                            $scope.params.MediaType = 16;
                            break;
                        case 'television':
                            $scope.status.accessAuthority.television = true;
                            $scope.cur.currMedia = $scope.cur.medias[6];
                            $scope.params.MediaType = 15;
                            break;
                        case 'tiktok':
                            $scope.status.accessAuthority.tiktok = true;
                            $scope.cur.currMedia = $scope.cur.medias[8];
                            $scope.params.MediaType = 17;
                            break;
                        case 'baijiahao':
                            $scope.status.accessAuthority.baijiahao = true;
                            $scope.cur.currMedia = $scope.cur.medias[9];
                            $scope.params.MediaType = 18;
                            break;
                        case 'qiehao':
                            $scope.status.accessAuthority.qiehao = true;
                            $scope.cur.currMedia = $scope.cur.medias[10];
                            $scope.params.MediaType = 19;
                            break;
                        case 'toutiao':
                            $scope.status.accessAuthority.toutiao = true;
                            $scope.cur.currMedia = $scope.cur.medias[11];
                            $scope.params.MediaType = 20;
                            break;
                        case 'kuaishou':
                            $scope.status.accessAuthority.kuaishou = true;
                            $scope.cur.currMedia = $scope.cur.medias[12];
                            $scope.params.MediaType = 25;
                            break;
                    }
                }
                deferred.resolve(status);
            });
            return deferred.promise;
        }

        /**
         * [initializeScapp description]初始化数采APP渠道
         * @return {[type]} [description]
         */
        function initializeScapp() {
            var params = {
                serviceid: 'mlf_appexchange',
                methodname: 'getColumns',
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                $scope.data.app.appListData = data;
                $scope.data.app.appListData[0].NAME = '频道';
                $scope.data.app.appListData[1].NAME = '地市';
                $scope.data.app.appListData[0].ZONE_COLUMNS = data[0].COLUMNS;
                $scope.data.app.appListData[1].ZONE_COLUMNS = data[1].COLUMNS;
                delete $scope.data.app.appListData[0].COLUMNS;
                delete $scope.data.app.appListData[1].COLUMNS;
            });
        }
        // 异步加载树
        $scope.showToggle = function (node, platform) {
            childrenTree(node, platform);
        };

        /**
         * [childrenTree description] 子树
         * @param   {[type]}  node      [node description]
         * @param   {[type]}  platform  [platform description]
         * @return  {[type]}            [return description]
         */
        function childrenTree(node, platform) {
            var deffer = $q.defer();
            if (node.HASCHILDREN == 'true' && (angular.isUndefined(node.CHILDREN) || node.CHILDREN.length === 0)) {
                var params = {
                    serviceid: 'mlf_mediasite',
                    methodname: 'queryClassifyByChnl',
                    ChannelId: node.CHANNELID,
                    platform: platform
                };
                trsHttpService.httpServer('/wcm/mlfcenter.do', params, 'get').then(function (data) {
                    node.CHILDREN = data.CHILDREN;
                    deffer.resolve(data.CHILDREN);
                });
            }
            return deffer.promise;
        }

        /**
         * [changeAppSingleRadio description]单项选择数采app的频道
         * @param  {[obj]} item [description]
         * @return {[type]}      [description]null
         */
        $scope.changeAppSingleRadio = function (item) {
            var flag = true;
            var index = '';
            $scope.data.scapp.selectedAppData = item;
            for (var i = 0; i < $scope.path.pathArray.length; i++) {
                if ($scope.path.pathArray[i].mediaType === '') {
                    flag = false;
                    index = i;
                    break;
                }
            }
            if (flag === true) {
                $scope.path.pathArray.push({
                    mediaName: 'APP',
                    mediaType: '',
                    siteName: $scope.data.app.selectedItem.SITEDESC,
                    channelName: item.NAME,
                    channelId: item.ID,
                });
            } else {
                $scope.path.pathArray[index].siteName = $scope.data.app.selectedItem.SITEDESC;
                $scope.path.pathArray[index].channelName = item.NAME;
                $scope.path.pathArray[index].channelId = item.ID;
            }
            setSelectedArrFn('', '', item.ID);
        };

        /**
         * [tvSelectToggle description] 电视栏目选择/取消选择
         * @param  {[type]} column [description]
         * @return {[type]}        [description]
         */
        $scope.tvSelectToggle = function (column) {
            if ($scope.data.television.selectedArray.indexOf(column.CHANNELID) < 0) {
                $scope.data.television.selectedArray.push(column.CHANNELID);
                getSelectedChannel(column);
            } else {
                $scope.data.television.selectedArray.splice($scope.data.television.selectedArray.indexOf(column.CHANNELID), 1);
                angular.forEach($scope.path.pathArray, function (data, index, path) {
                    if (data.channelId == column.CHANNELID) {
                        $scope.deleteTrack(index, path[index]);
                    }
                });
            }
        };

        /**
         * [broadcastSelectToggle description] 电视栏目选择/取消选择
         * @param  {[type]} column [description]
         * @return {[type]}        [description]
         */
        $scope.broadcastSelectToggle = function (column) {
            if ($scope.data.broadcast.selectedArray.indexOf(column.CHANNELID) < 0) {
                $scope.data.broadcast.selectedArray.push(column.CHANNELID);
                getSelectedChannel(column);
            } else {
                $scope.data.broadcast.selectedArray.splice($scope.data.broadcast.selectedArray.indexOf(column.CHANNELID), 1);
                angular.forEach($scope.path.pathArray, function (data, index, path) {
                    if (data.channelId == column.CHANNELID) {
                        $scope.deleteTrack(index, path[index]);
                    }
                });
            }
        };
    },
]);
